// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.border-3[data-v-34127e96] {\n  border-width: 3px !important;\n}\n", ""]);
// Exports
module.exports = exports;
